// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8777":"8da9171f","9586":"988e05ef"}[chunkId] + ".chunk.css";
};